import { ReactNode } from 'react';
import styled from 'styled-components';
import { bouTextFontStyle } from '../../../../generic/content/texts/bou-text/text-style';

export function ImpactLensLegendItem(props: { text: ReactNode; color: string }): JSX.Element {
  return (
    <Item>
      <Icon style={{ backgroundColor: props.color }} />
      <Title>{props.text}</Title>
    </Item>
  );
}

const Title = styled.div`
  margin-left: 4px;
`;

const Icon = styled.div`
  width: 1.2em;
  height: 1.2em;
  border: 1px solid transparent;
  border-radius: 100%;
  flex-grow: 0;
  flex-shrink: 0;
`;

const Item = styled.div`
  display: flex;
  ${bouTextFontStyle};
  align-items: center;
`;
